const DENIED = { analytics_storage: "denied", ad_storage: "denied", ad_user_data: "denied", ad_personalization: "denied" }
let initialized = false
let contextTimer
let previousLocation = null

function configuration() {
  const meta = document.querySelector('meta[name="optofriend-analytics"]')
  return meta ? JSON.parse(meta.content) : null
}

function consent(preference) {
  const analytics = ["all", "analytics"].includes(preference)
  const advertising = ["all", "advertising"].includes(preference)
  return { analytics_storage: analytics ? "granted" : "denied", ad_storage: advertising ? "granted" : "denied",
    ad_user_data: advertising ? "granted" : "denied", ad_personalization: "denied" }
}

function safeReferrer() {
  if (previousLocation) return previousLocation
  try {
    return document.referrer ? new URL(document.referrer).origin : ""
  } catch {
    return ""
  }
}

function captureContext(config) {
  const form = document.querySelector('[data-analytics-context]')
  if (!form) return
  window.gtag("get", config.measurementId, "client_id", (clientId) => {
    window.gtag("get", config.measurementId, "session_id", (sessionId) => {
      if (!form.isConnected || !clientId || !sessionId) return
      form.elements.client_id.value = clientId
      form.elements.session_id.value = sessionId
      form.requestSubmit()
    })
  })
}

document.addEventListener("turbo:load", () => {
  clearTimeout(contextTimer)
  const config = configuration()
  if (!config?.enabled) return

  window.dataLayer ||= []
  window.gtag ||= function() { window.dataLayer.push(arguments) }
  if (!initialized) {
    window.gtag("consent", "default", DENIED)
    initialized = true
  }
  const signals = consent(window.navigator?.globalPrivacyControl ? "none" : config.preference)
  window.gtag("consent", "update", signals)
  if (signals.analytics_storage === "denied" && signals.ad_storage === "denied") return

  const referrer = safeReferrer()
  window.gtag("set", { user_id: signals.analytics_storage === "granted" ? config.userId : null,
    page_location: config.pageLocation, page_title: config.pageTitle, page_referrer: referrer })
  if (signals.analytics_storage !== "granted") return

  if (!document.querySelector('script[data-optofriend-google-tag]')) {
    if (!/^G-[A-Z0-9]+$/.test(config.measurementId)) return
    window.gtag("js", new Date())
    window.gtag("config", config.measurementId, {
      send_page_view: true,
      allow_google_signals: false,
      allow_ad_personalization_signals: false,
      user_id: config.userId,
      page_location: config.pageLocation,
      page_title: config.pageTitle,
      page_referrer: referrer
    })
    const script = document.createElement("script")
    script.async = true
    script.dataset.optofriendGoogleTag = "true"
    script.src = `https://www.googletagmanager.com/gtag/js?id=${config.measurementId}`
    document.head.appendChild(script)
  } else {
    window.gtag("config", config.measurementId, {
      update: true,
      send_page_view: false,
      user_id: config.userId,
      page_location: config.pageLocation,
      page_title: config.pageTitle,
      page_referrer: referrer
    })
  }

  const location = new URL(config.pageLocation)
  previousLocation = `${location.origin}${location.pathname}`
  contextTimer = setTimeout(() => captureContext(config), 2000)
})

document.addEventListener("turbo:before-cache", () => clearTimeout(contextTimer))
